import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
            {aboutData.title}
          </h2>
          <div className="space-y-5 text-left">
            {aboutData.paragraphs.map((text, idx) => (
              <p
                key={idx}
                className="text-sm md:text-base text-foreground-600 leading-relaxed"
              >
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}